import React from "react";
import { Route, Routes } from "react-router-dom";
import ChatPage from "../../pages/ChatPage";
import About from "../../pages/AboutPage";
import Layout from "./Layout";
import HomePage from "../../pages/HomePage";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="chat" element={<ChatPage />} />
        <Route path="about" element={<About />} />
      </Route>
    </Routes>
  );
};

export default Router;
